import axios from "axios";

const GET_CONFIGURATIONS_URL = "api/config";
const SET_CONFIGURATIONS_URL = "api/config";
const GET_SONGS_URL = "api/getMusic";

export default {
  getConfigurationsFromServer,
  setConfigurations,
  getSongsFromServer
};

function getConfigurationsFromServer() {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.get(GET_CONFIGURATIONS_URL);
      resolve(response.data);
    } catch (e) {
      reject(e);
    }
  });
}

function setConfigurations(configs) {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.post(SET_CONFIGURATIONS_URL, { configs });
      resolve(response.data);
    } catch (e) {
      reject(e);
    }
  });
}

function getSongsFromServer() {
  return new Promise(async (resolve, reject) => {
    try {
      const songResponse = await axios.get(GET_SONGS_URL);
      resolve(songResponse.data.data);
    } catch (e) {
      reject(e);
    }
  });
}
